<template>
  <span class="label-container">
    <label aria-hidden="true" class="v-label v-label--active">{{ label }}</label>
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    label: {type: String},
  },
}
</script>

<style scoped>
.label-container {
  position: relative;
  padding-top: 14px;
  margin-right: 4px;
}
.v-label {
  position: absolute;
  left: 8px;
  top: 6px;
  overflow: hidden;
  font-size: 16px !important;
  font-weight: 500 !important;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  transform: translateY(-10px) scale(0.75);
  transform-origin: top left;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
